import { useRef, useState } from "react";
import SectionHeading from "./SectionHeading";

type Bullet = { id: number; text: string; top: number; color: number; delay: number };

const INIT_BULLETS: Bullet[] = [
  { id: 1, text: "前排围观，瓜子备好", top: 12, color: 0, delay: 0 },
  { id: 2, text: "哈哈哈哈这段我笑到打鸣", top: 30, color: 1, delay: 1 },
  { id: 3, text: "有被感动到，纸巾都不够了", top: 48, color: 2, delay: 2 },
  { id: 4, text: "这波操作我给满分", top: 66, color: 0, delay: 3 },
  { id: 5, text: "来了来了，今日份快乐送达", top: 82, color: 1, delay: 4 },
  { id: 6, text: "评论区人均段子手实锤", top: 22, color: 2, delay: 6 },
  { id: 7, text: "吃瓜吃到自己家系列", top: 40, color: 0, delay: 8 },
  { id: 8, text: "弹幕护体！", top: 58, color: 1, delay: 10 },
  { id: 9, text: "这瓜保熟吗？我直接好家伙", top: 74, color: 2, delay: 12 },
];

const COLORS = [
  "text-primary-300",
  "text-accent-300",
  "text-secondary-300",
];

const QUICK = ["哈哈哈笑不活了", "有被治愈到", "前排围观", "弹幕护体", "这波操作我给满分", "太真实了吧"];

let nextId = 100;

export default function DanmakuStage() {
  const [bullets, setBullets] = useState<Bullet[]>(INIT_BULLETS);
  const [input, setInput] = useState("");
  const timerRef = useRef<number | null>(null);

  const lanes = [10, 24, 38, 52, 66, 80];

  const addBullet = (text: string) => {
    const clean = text.trim();
    if (!clean) return;
    const lane = lanes[Math.floor(Math.random() * lanes.length)];
    const newBullet: Bullet = {
      id: nextId++,
      text: clean.slice(0, 24),
      top: lane,
      color: Math.floor(Math.random() * COLORS.length),
      delay: 0,
    };
    setBullets((prev) => [...prev, newBullet]);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      setBullets((prev) => prev.filter((b) => b.id !== newBullet.id));
    }, 11500);
  };

  return (
    <section id="danmaku" className="relative overflow-hidden bg-accent-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="弹幕互动"
          title="在瓜田剧场里"
          accent="一起刷屏"
          desc="输入你想说的话，让弹幕划过屏幕。文明发言，做一个快乐的吃瓜群众。"
        />

        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-background-950 to-background-800 p-6 md:p-8 shadow-[inset_0_1px_0_0_oklch(var(--background-700))]">
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.06] text-[120px] select-none">
            🍉
          </div>
          <div className="relative">
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50"></span>
                </span>
                LIVE 正在围观
              </span>
              <span className="hidden sm:inline-flex items-center gap-1 whitespace-nowrap text-xs text-background-300">
                <i className="ri-magic-line"></i>
                今日已收获 <b className="text-background-50">86,921</b> 条弹幕
              </span>
            </div>

            <div className="relative mt-4 h-64 overflow-hidden rounded-2xl bg-background-900/70 ring-1 ring-background-700">
              {bullets.map((b) => (
                <span
                  key={b.id}
                  style={{ top: `${b.top}%`, animationDelay: `${b.delay}s` }}
                  className={`bullet-move absolute left-0 whitespace-nowrap rounded-full bg-background-950/70 px-3 py-1 text-sm md:text-base ${COLORS[b.color]} border border-background-700`}
                >
                  {b.text}
                </span>
              ))}
            </div>

            <div className="mt-5 flex flex-col gap-3">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  addBullet(input);
                  setInput("");
                }}
                className="flex flex-col sm:flex-row items-stretch gap-2.5"
              >
                <label htmlFor="bullet-input" className="sr-only">
                  发送弹幕
                </label>
                <input
                  id="bullet-input"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  maxLength={30}
                  placeholder="说点什么，让大家都看到…"
                  className="flex-1 rounded-full border-0 bg-background-900 px-5 py-2.5 text-sm text-background-50 ring-1 ring-background-700 placeholder:text-background-400 focus:ring-2 focus:ring-accent-400 outline-none"
                />
                <button
                  type="submit"
                  className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-6 py-2.5 text-sm text-background-50 hover:bg-accent-600 transition-colors"
                >
                  <i className="ri-send-plane-fill"></i>
                  发送弹幕
                </button>
              </form>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs text-background-400">快速说一句：</span>
                {QUICK.map((q) => (
                  <button
                    key={q}
                    type="button"
                    onClick={() => addBullet(q)}
                    className="whitespace-nowrap rounded-full bg-background-800 px-3 py-1 text-xs text-background-200 ring-1 ring-background-700 hover:bg-background-700 hover:text-background-50 transition-colors"
                  >
                    {q}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}